<template>
  <div class="set-player-card">
    <div class="form">
      <div class="card-box" @click="show = true">
        <div class="title">
          <div>球员卡模版</div>
          <van-icon name="arrow" />
        </div>
        <div class="list">
          <div class="item" v-for="item in playerForm.list" :key="item.id">
            <img :src="imageView(item.poster, 216, 270)" />
          </div>
        </div>
      </div>
      <div class="form-item">
        <van-field name="switch" input-align="right" label="线下打印服务">
          <template #input>
            <van-switch v-model="playerForm.status" :inactive-value="0" :active-value="1" size="20" />
          </template>
        </van-field>
      </div>
      <div class="form-item">
        <van-field name="stepper" input-align="right" label="线下打印收款">
          <template #input>
            <van-stepper min="5.99" input-width="50px" v-model="playerForm.printPrice" :decimal-length="2" />
          </template>
        </van-field>
      </div>
    </div>
    <div class="footer">
      <div @click="setPlayer">保存</div>
    </div>
    <van-popup v-model="show" round position="bottom" :style="{ height: '500px' }">
      <div class="popup-box">
        <div class="tabs">
          <van-tabs v-model="active" @change="getPlayerCardList">
            <van-tab title="球员卡"></van-tab>
            <van-tab title="纪念卡"></van-tab>
            <van-tab title="比赛卡"></van-tab>
          </van-tabs>
        </div>
        <div class="list">
          <div class="item" v-for="item in playerList" :key="item.id" @click="selectCard(item)">
            <div class="img">
              <img :src="imageView(item.poster, 408, 555)" />
              <div class="name">{{ item.name }}</div>
            </div>
            <div class="but" v-if="getClass(item.id)">选 中</div>
            <div v-else class="active">取消选中</div>
          </div>
        </div>
        <div class="footer">
          <div @click="show = false">保存</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { playerList } from '@/utils/player-data'
import { playerCardReseller, getPlayerCardReseller, getPlayerCardTemplateList } from '@/api/match'
import { QNImageUtil } from '@/utils'
import Vue from 'vue';
import { Icon, Popup, Toast, Field, Switch, Stepper, Tab, Tabs } from 'vant';
Vue.use(Icon).use(Popup).use(Toast).use(Field).use(Switch).use(Stepper).use(Tab).use(Tabs);
export default {
  data() {
    return {
      match: {},
      playerList: playerList,
      resellerId: '',
      unionMatchId: '',
      playerForm: {
        list: [], // 选中的球员卡模板
        status: 0,
        printPrice: 5.99,
        resellerId: '',
        objType: '',
        objId: ''
      },
      show: false,
      active: 0
    };
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId  // matchiId

    this.playerForm.objId = this.$route.params.unionMatchId
    this.playerForm.objType = this.$route.query.objType
    this.getPlayerCardReseller()
    this.getPlayerCardList()
  },
  methods: {
    getPlayerCardReseller() {
      const obj = {
        objType: this.playerForm.objType,
        objId: this.playerForm.objId,
      }
      getPlayerCardReseller(obj).then(res => {
        const detail = res.data.detail
        if (!detail.id) return
        const obj = {
          status: detail.status,
          printPrice: (detail.printPrice / 100).toFixed(2),
          resellerId: detail.id,
          objType: this.playerForm.objType,
          objId: detail.objId,
          list: JSON.parse(detail.templates)
        }
        this.playerForm = obj
      })
    },
    getPlayerCardList() {
      getPlayerCardTemplateList({ categoryId: this.active + 1 }).then(res => {
        const { data } = res
        this.playerList = data.list
      })
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    },
    getClass(id) {
      const list = this.playerForm.list
      const index = list.findIndex(item => item.id == id)
      return index === -1
    },
    selectCard(obj) {
      const list = this.playerForm.list
      const index = list.findIndex(item => item.id == obj.id)
      if (index === -1) {
        if (list.length >= 6) {
          Toast('最多可选择6个');
        } else {
          const obj2 = {
            ...obj,
            typeName: this.active === 0 ? '球员卡' : this.active === 1 ? '纪念卡' : '比赛卡'
          }
          list.push(obj2)
        }
      } else {
        list.splice(index, 1)
      }
    },
    setPlayer() {
      if (this.playerForm.list.length === 0) {
        return Toast('请选择球员卡模板')
      }
      const playerForm = this.playerForm
      const params = {
        status: playerForm.status,
        printPrice: Math.round(playerForm.printPrice * 100),
        resellerId: playerForm.resellerId,
        objType: playerForm.objType,
        objId: playerForm.objId,
        banner: this.match.backgroundImage2
      }
      const templates = playerForm.list.map(item => item.id).join()
      params.templateIds = templates
      playerCardReseller(params).then(res => {
        const data = res.data
        this.playerForm.resellerId = data.resellerId
        Toast('设置成功！')
        this.$router.push({ path: `/match-manage/player-card-order-list/${this.unionMatchId}`, query: { resellerId: data.resellerId } })
      })
    }
  },
};
</script>

<style scoped lang="scss">
.set-player-card {
  padding: 12px;

  .form {
    .card-box {
      padding: 8px 0;
      border-bottom: 1px solid #DCDFE6;

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding: 0 16px;
      }

      .list {
        display: flex;
        padding: 0 6px;
        padding-top: 8px;
        justify-content: space-between;

        .item {
          width: 60px;
          background: #F5F5F5;

          img {
            width: 100%;
          }
        }
      }
    }

    .form-item {
      border-bottom: 1px solid #DCDFE6;
    }

  }

  .popup-box {
    position: relative;

    .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      overflow: auto;
      padding: 18px;
      padding-top: 0px;
      padding-bottom: 62px;
      height: 380px;

      .item {
        margin-top: 20px;
        border-radius: 4px;
        width: 28%;
        overflow: hidden;

        .img {
          width: 100%;
          height: 135px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          overflow: hidden;
          position: relative;
          background: #F5F5F5;

          img {
            width: 108px;
            height: 135px;
          }

          .name {
            position: absolute;
            bottom: 0px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #fff;
            margin-top: 12px;
            text-align: center;
            padding: 2px 0;
            background-color: rgba(0, 0, 0, 0.6);
          }
        }

        .but {
          text-align: center;
          // background-color: #007AFF;
          border: 1px solid #007AFF;
          color: #007AFF;
          border-radius: 8px;
          padding: 4px 0;
          margin-top: 8px;
          font-size: 12px;
        }

        .active {
          text-align: center;
          background-color: #007AFF;
          border: 1px solid #007AFF;
          color: #fff;
          border-radius: 8px;
          padding: 4px 0;
          margin-top: 8px;
          font-size: 12px;
        }
      }
    }


  }

  .footer {
    width: 100%;
    position: fixed;
    left: 0px;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    padding: 12px;
    box-sizing: border-box;

    div {
      width: 80%;
      color: #fff;
      text-align: center;
      background-color: #007AFF;
      padding: 6px 0;
      border-radius: 4px;
    }
  }
}
</style>
